module.exports = __webpack_public_path__ + "img/4.85cf20f6.jpg";